import axios from "axios";
import { getConfig } from "../helpers/config";

export class EmailService {
  baseAPIUrl = `${getConfig()?.url}email`;

  checkEmailMassiveRettificaDomanda = async (avvisoId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/aggiorna-isee`)
                      .then((res) => res.data);
  }

  inviaEmailMassiveRettificaDomanda = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/aggiorna-isee`)
                      .then((res) => res.data);
  }

  checkEmailMassiveSecondoAccesso = async (avvisoId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/secondo-accesso`)
                      .then((res) => res.data);
  }

  inviaEmailMassiveSecondoAccesso = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/secondo-accesso`)
                      .then((res) => res.data);
  }

  checkEmailMassiveIban = async (avvisoId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/esito-iban`)
                      .then((res) => res.data);
  }

  inviaEmailMassiveIban = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/esito-iban`)
                      .then((res) => res.data);
  }

  checkEmailMassiveRettificaIban = async (avvisoId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/rettifica-iban`)
                      .then((res) => res.data);
  }

  inviaEmailMassiveRettificaIban = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/rettifica-iban`)
                      .then((res) => res.data);
  }

  checkEmailMassiveTerzoAccesso = async (avvisoId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/terzo-accesso`)
                      .then((res) => res.data);
  }

  inviaEmailMassiveTerzoAccesso = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/terzo-accesso`)
                      .then((res) => res.data);
  }

  checkEmailMassiveRettificaIseeIbanDomanda = async (avvisoId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/aggiorna-isee-iban`)
                      .then((res) => res.data);
  }

  inviaEmailMassiveRettificaIseeIbanDomanda = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/aggiorna-isee-iban`)
                      .then((res) => res.data);
  }

  checkEmailMassiveEsitoArs = async (avvisoId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/esito-ars`)
                      .then((res) => res.data);
  }

  inviaEmailMassiveEsitoArs = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/esito-ars`)
                      .then((res) => res.data);
  }

  rescheduleEmailMassive = async (tipologieMassive, faseId) => {
    return await axios.get(`
      ${this.baseAPIUrl}/rescheduleEmailMassive?tipologiaMassive=${tipologieMassive}&faseId=${faseId ?? ''}`
    ).then((res) => res.data);
  }
}
